import http from "@/plugins/axios";
import echarts from "echarts";

export default {
    export2Excel(columns,list){
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../../excel/Export2Excel');
            let tHeader = []
            let filterVal = []
            console.log(columns)
            if(!columns){
                return;
            }
            columns.forEach(item =>{
                tHeader.push(item.title)
                filterVal.push(item.key)
            })
            const data = list.map(v => filterVal.map(j => v[j]))
            export_json_to_excel(tHeader, data, '财务对账统计报表');
        })
    },
    getRecord(requestUrl) {
        return http.get({
            url: requestUrl
        });
    },
    queryAccountReconciliation(data){
        return http.post({
            url: '/admin/account/reconciliation',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    drawLineBox(elementId, series, xAxis){
      let chartLine = echarts.init(document.getElementById(elementId));
      const option = {
        title: {
          text: '财务对账',
          x: 'left',
          y: 'top'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: true,
          x: 'center',
          y: 'top',
          data: series.filter((item)=>{return item.name})
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            dataZoom: {
              show: true,
              title: {dataZoom: '区域缩放', dataZoomReset: '区域缩放后退'}
            },
            dataView: {show: true, readOnly: true},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: [
          {
            show: true,
            type: 'category',
            name:'时间',
            data:xAxis,
          }
        ],
        yAxis: [
          {
            show: true,
            type: 'value',
            name:'币量',
            splitArea: {show: true}
          }
        ],
        series: series
      };
      chartLine.clear();
      chartLine.setOption(option);
    }

}